import React, { useState } from "react";
import { func } from "prop-types";
import { connect } from "react-redux";

import { forgotPassword } from "../../helper/api";
import { setLoading } from "../../helper/actions";

import TextField from "../../atoms/textfield";
import Button from "../../atoms/button";
import { isValidEmail } from "../../helper/utils";
import ErrorView from "../../molecules/error-view";
import SuccessView from "../../molecules/success-view";

import "./forgot-password.m.css";

const VERIFY_EMAIL_MESSAGE = "Please check your email to finish with password reset process";

const ForgotPassword = ({ setLoading }) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const setData = e => {
    setEmail(e.target.value);

    // If error has been set then remove it
    if (e.target.value && emailError) {
      setEmailError("");
    }
  };

  const onSubmitClick = event => {
    event.preventDefault();

    if (validate()) {
      // true -> field errors, false - no fields errors
      return;
    }

    setLoading(true);

    forgotPassword(email)
      .then(() => setSuccessMessage(VERIFY_EMAIL_MESSAGE))
      .catch(ex => setError(ex.message))
      .finally(() => setLoading(false));
  };

  const validate = () => {
    let flag = false;

    if (!email) {
      setEmailError("Email field cannot be left blank !!");
      flag = true;
    } else if (!isValidEmail(email)) {
      setEmailError("Invalid Email !!");
      flag = true;
    }

    return flag;
  };

  return (
    <form onSubmit={onSubmitClick}>
      <div styleName="wrapper">
        <ErrorView error={error} closeClick={() => setError(null)} />
        <SuccessView text={successMessage} closeClick={() => setSuccessMessage(null)} />
        <TextField
          value={email}
          error={emailError}
          placeholder="who@areyou.com"
          label="Email ID"
          type="email"
          name="email"
          onChange={setData}
        />
        <div styleName="actions-wrapper">
          <Button content="SUBMIT" type="submit" />
        </div>
      </div>
    </form>
  );
};

ForgotPassword.propTypes = {
  setLoading: func
};

const mapDispatchToProps = dispatch => ({
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

export default connect(
  null,
  mapDispatchToProps
)(ForgotPassword);
